import { fetch } from '@/common/request';

// Skill 注册
export interface SkillRegistryVo {
  id: number;
  name: string;
  description?: string;
  currentVersionId?: number;
  currentVersion?: string;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface SkillRegistryCreateReq {
  name: string;
  description?: string;
}

export interface SkillRegistryUpdateReq extends SkillRegistryCreateReq {
  id: number;
}

export interface SkillRegistryListReq {
  keyword?: string;
}

// Skill 版本
export interface SkillVersionVo {
  id: number;
  skillId: number;
  version: string;
  content: string;
  changeLog?: string;
  createdBy?: string;
  createdAt?: string;
  updatedBy?: string;
  updatedAt?: string;
}

export interface SkillVersionCreateReq {
  skillId: number;
  version: string;
  content: string;
  changeLog?: string;
}

export interface SkillVersionUpdateReq {
  id: number;
  content: string;
  changeLog?: string;
}

export interface SkillVersionListReq {
  skillId: number;
}

export interface SkillVersionSwitchReq {
  skillId: number;
  versionId: number;
}

export interface SkillLoadReq {
  id: number;
}

// Skill 注册 API
export function createSkillRegistry(params: SkillRegistryCreateReq): Promise<number> {
  return fetch(
    '/api/config/skill/registry/create',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function updateSkillRegistry(params: SkillRegistryUpdateReq): Promise<void> {
  return fetch(
    '/api/config/skill/registry/update',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function deleteSkillRegistry(id: number): Promise<void> {
  return fetch(
    '/api/config/skill/registry/delete',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function getSkillRegistryDetail(id: number): Promise<SkillRegistryVo> {
  return fetch(
    '/api/config/skill/registry/detail',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function getSkillRegistryList(params?: SkillRegistryListReq): Promise<SkillRegistryVo[]> {
  return fetch(
    '/api/config/skill/registry/list',
    {
      method: 'POST',
      body: JSON.stringify(params || {}),
    },
    true
  );
}

export function loadSkill(id: number): Promise<void> {
  return fetch(
    '/api/config/skill/registry/load',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function loadAllSkills(): Promise<void> {
  return fetch(
    '/api/config/skill/registry/loadAll',
    {
      method: 'POST',
    },
    true
  );
}

// Skill 版本 API
export function createSkillVersion(params: SkillVersionCreateReq): Promise<number> {
  return fetch(
    '/api/config/skill/version/create',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function updateSkillVersion(params: SkillVersionUpdateReq): Promise<void> {
  return fetch(
    '/api/config/skill/version/update',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function deleteSkillVersion(id: number): Promise<void> {
  return fetch(
    '/api/config/skill/version/delete',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function switchSkillVersion(params: SkillVersionSwitchReq): Promise<SkillVersionVo> {
  return fetch(
    '/api/config/skill/version/switch',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getSkillVersionList(skillId: number): Promise<SkillVersionVo[]> {
  return fetch(
    '/api/config/skill/version/list',
    {
      method: 'POST',
      body: JSON.stringify({ skillId }),
    },
    true
  );
}

export function getSkillVersionDetail(id: number): Promise<SkillVersionVo> {
  return fetch(
    '/api/config/skill/version/detail',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}